import styled from 'styled-components';

import InfoSvg from '../../../assets/icons/info.svg';
import ExitSvg from '../../../assets/icons/x-close.svg';
import { colors, MOBILE_BREAKPOINT } from '../../constants';
import { pxToRem } from '../../utilities/utility';
import InfoGraySvg from 'src/assets/icons/info-gray-tooltip-icon.svg';

interface StyledProps {
  showToolTip?: boolean;
  showModal?: boolean;
  top?: string;
}

export const ToolTipButton = styled.button`
  z-index: 3; // makes the mobile modal appear over the modal mask
  position: relative;
  height: 1.5rem;
  width: 1.5rem;
  margin: 0 0 0 0.125rem;
  cursor: pointer;
  &:focus-visible {
    border-radius: 0.25rem;
    outline: 0.125rem solid ${colors.UI_PRIMARY};
    outline-offset: -0.0625rem;
  }
`;
ToolTipButton.displayName = 'ToolTipButton';

export const ToolTipContainer = styled.div<StyledProps>`
  position: absolute;
  bottom: -0.5rem;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.1s ease-in-out;
  filter: drop-shadow(0 0.0625rem 0.25rem rgba(0, 0, 0, 0.26));

  ${(p: StyledProps) =>
    p.showToolTip &&
    `
    cursor: default;
    pointer-events: auto;
    opacity: 1;
  `};
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    position: fixed;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;
ToolTipContainer.displayName = 'ToolTipContainer';

// Backdrop of the expanded tooltip where the text is displayed
export const ToolTipBubble = styled.div`
  position: absolute;
  width: 18.25rem;
  margin: 0.25rem 0 0 -8.75rem;
  border-radius: 0.5rem;
  padding: ${pxToRem(24)};
  text-align: left;
  background-color: ${colors.DROPDOWN_BACKGROUND};
  @media (max-width: 40rem) {
    // shifts when bubble overlaps with edge of card
    width: 16rem;
    margin: 0.25rem 0 0 -9.5rem;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    position: relative;
    width: 100%;
    margin: 0;
    cursor: default;
    pointer-events: auto;
    padding: ${pxToRem(32)} ${pxToRem(24)};
    overflow: scroll;
    opacity: 1;
    z-index: 3;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    min-height: 12.375rem;
  }
  &:focus-visible {
    outline: none;
  }
`;
ToolTipBubble.displayName = 'ToolTipBubble';

export const ToolTipHeading = styled.p`
  margin: 0.75rem 0 0;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.53125rem;
  color: ${colors.TEXT_PRIMARY};
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 1rem;
    line-height: 1.5rem;
  }
`;
ToolTipHeading.displayName = 'ToolTipText';

export const ToolTipText = styled.p`
  margin: 0.625rem 0 0;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.53125rem;
  color: ${colors.TEXT_PRIMARY};
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 1rem;
    line-height: 1.5rem;
  }
`;
ToolTipText.displayName = 'ToolTipText';

// Attached to the expanded tooltip bubble, points up towards the (i) icon
export const Caret = styled.div`
  position: absolute;
  height: 2rem;
  width: 2rem;
  margin: 0 0 0 -0.25rem;
  transform: rotate(45deg);
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: none;
  }
`;
Caret.displayName = 'Caret';

export const CaretMask = styled.div`
  z-index: 2;
  position: absolute;
  height: 1.5rem;
  width: 1.5rem;
  margin: -0.0625rem 0 0 0;
  border-radius: 0.125rem;
  transform: rotate(45deg);
  background: ${colors.DROPDOWN_BACKGROUND};
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: none;
  }
`;
CaretMask.displayName = 'CaretMask';

// Inline (i) icon that toggles the tooltip on-click
export const InfoIcon = styled(InfoSvg)`
  margin: 0 0 -0.1875rem;
  pointer-events: none;
`;
InfoIcon.displayName = 'InfoIcon';

// Inline (i) icon that toggles the tooltip on-click
export const InfoGrayIcon = styled(InfoGraySvg)`
  margin: 0 0 -0.1875rem;
  pointer-events: none;
`;
InfoIcon.displayName = 'InfoIcon';

// X-button in tooltip modal (only visible on mobile UI)
export const ExitIcon = styled(ExitSvg)`
  display: none;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    position: absolute;
    top: 0.9375rem;
    right: 0.9375rem;
    display: inline;
  }
`;

export const CloseButton = styled.button`
  cursor: pointer;
`;

// Dark overlay behind expanded tooltip modal on mobile UI
export const ModalMask = styled.div`
  display: none;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    z-index: 2;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background: #333333;
    opacity: 0.25;
  }
`;
ModalMask.displayName = 'ModalMask';
// #endregion
